import React from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
const { Paragraph: AntParagraph } = Typography;

type Height = `${number}px` | `${number}%`;
type MarginBottom = `${number}px` | 0;
type MarginTop = `${number}px` | 0;

interface CustomStyles {
  marginTop?: CSSSize;
  marginBottom?: MarginBottom;
  height?: Height;
  color?: Color;
  fontSize?: number;
  lineHeight?: number;
}

interface PProps {
  children: React.ReactNode;
  className?: string;
  customStyle?: CustomStyles;
}

function P({ children, className, customStyle }: PProps): JSX.Element {
  return (
    <StyledParagraph customstyles={customStyle} className={className}>
      {children}
    </StyledParagraph>
  );
}

const StyledParagraph = styled(AntParagraph)<{ customstyles?: CustomStyles }>`
  &.ant-typography {
    margin-top: ${props => props.customstyles?.marginTop};
    margin-bottom: ${props => props.customstyles?.marginBottom};
    margin-top: ${props => props.customstyles?.marginTop};
    height: ${props => props.customstyles?.height};
    color: ${props => props.customstyles?.color};
    font-size: ${props => props.customstyles?.fontSize && `${props.customstyles?.fontSize}px`};
    line-height: ${props =>
      props.customstyles?.lineHeight && `${props.customstyles?.lineHeight}px`};
  }
`;

export default P;
